import { generateQueryDSLQuery } from '@components/Filtering/QueryGenerators/JavaQueryBuilder';
import Connector, { takeQuery } from '../../agent';
import {
  GET_REPORT,
  GET_BUILDINGS_REPORT_PATH,
  GET_PDF_FORMAT,
  GET_EXCEL_FORMAT,
  GET_CSV_REPORT,
  GET_SELECTED_INVENTORIES_REPORT_PATH,
  GET_INVENTORIES_LIST_CSV
} from './types';

const Reports = {
  getReport: ({ reportPath, ids, locReportReqDtoList, queryParams }) => {
    let filename;
    // building summary
    if (reportPath === GET_BUILDINGS_REPORT_PATH && locReportReqDtoList.length === 1) {
      filename = `Building_summary_${locReportReqDtoList[0].id}.pdf`;
    } else if (reportPath === GET_BUILDINGS_REPORT_PATH) {
      filename = `Building_summaries.pdf`;
    }
    // inventory pdf
    else if (
      reportPath.includes(GET_SELECTED_INVENTORIES_REPORT_PATH + GET_PDF_FORMAT) &&
      ids.length === 1
    ) {
      filename = `Inventory_${ids[0]}.pdf`;
    } else if (reportPath.includes(GET_SELECTED_INVENTORIES_REPORT_PATH + GET_PDF_FORMAT)) {
      filename = `Inventories.pdf`;
    } else if (reportPath.includes(GET_SELECTED_INVENTORIES_REPORT_PATH + GET_EXCEL_FORMAT)) {
      filename = `Inventories.xlsx`;
    }

    return Connector.api.pdf(
      `/reports${reportPath}`,
      null,
      queryParams,
      filename,
      'post',
      ids || locReportReqDtoList
    );
  },

  getCsvReport: ({ ids, filters, filterstate, language}) => {
    const filename = `Inventories.csv`;
    
    const body = {
      filename,
      ids, 
      search: generateQueryDSLQuery(
        filters,
        filters.possibleFieldsList,
        filterstate.filterLogicalOperator
      ).search,
      visibleColumns: filterstate.visibleColumns.map(value => value.key),
      sortField: filterstate.sort.sortField,
      sortDirection: filterstate.sort.sortDirection,
      lang: language
    }

    return Connector.api.csv(
      GET_INVENTORIES_LIST_CSV,
      null, 
      null,
      'post',
      body
    )
  }
};

const locationSagas = [
  takeQuery(GET_REPORT, {
    api: Reports.getReport,
  }),
  takeQuery(GET_CSV_REPORT, {
    api: Reports.getCsvReport,
  }),
];

export default locationSagas;
